// Единое ядро позиционирования донных сливов 
import { DRAIN_CONFIG } from './config';

/**
 * Расчет масштаба модели и компенсации высоты
 */
export const getDrainModelParams = (depth) => {
    const baseDepth = DRAIN_CONFIG.heights?.default?.baseDepth ?? 1.5;
    const baseScaleValue = DRAIN_CONFIG.model?.scale ?? 1;
    const baseScale = [0.15 * baseScaleValue, 0.15 * baseScaleValue, 0.15 * baseScaleValue];

    let scaleFactor = 1.0;

    // Вычисляем масштаб от глубины
    if (depth !== null && depth !== undefined && depth < baseDepth) {
        const minScaleFactor = 0.4;
        scaleFactor = minScaleFactor + (1 - minScaleFactor) * (depth / baseDepth);
    }

    // Расчет компенсации высоты.
    // Важно: компенсация должна опускать модель вниз при уменьшении масштаба,
    // чтобы слив не оказывался "выше" пола.
    let compensation = 0;
    if (scaleFactor < 1.0) {
        const baseHeight = baseScale[1];
        const heightReduction = baseHeight * (1 - scaleFactor);
        const dropFactor = DRAIN_CONFIG.model?.heightCompensation?.reducedScaleDropFactor ?? 0.72;
        compensation = -heightReduction * dropFactor;
    }

    return {
        scale: [baseScale[0] * scaleFactor, baseScale[1] * scaleFactor, baseScale[2] * scaleFactor],
        heightCompensation: compensation
    };
};

export const getDrainScale = (depth) => {
    const params = getDrainModelParams(depth);
    return params.scale;
};

export const getDrainModelPath = () => DRAIN_CONFIG.modelPath;
